import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CryptoService } from '../../../../services/security/crypto.service';
import { environment } from '../../../../../environments/environment';

import Swal from 'sweetalert2';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject<void>();
  loginForm: FormGroup;
  esqueciSenhaForm: FormGroup;
  esqueciSenha: boolean;
  selecionarEstrutura: boolean;
  estruturas: any;
  esqueciSenhaMsg = {
    type: '',
  };

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private crypto: CryptoService
  ) {
    this.loginForm = this.formBuilder.group({
      login: ['', [Validators.required]],
      senha: ['', [Validators.required, Validators.minLength(6)]],
    });

    this.esqueciSenhaForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
  // Reconhece os campos
  get login() {
    return this.loginForm.get('login');
  }
  get senha() {
    return this.loginForm.get('senha');
  }
  get email() {
    return this.esqueciSenhaForm.get('email');
  }

  ngOnInit(): void {

    if (this.router.url === '/selecionar-estrutura') {
      this.estruturas = JSON.parse(localStorage.getItem('estruturas'));
      this.selecionarEstrutura = true;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  recuperarSenha(esqueciSenhaForm) {
    if (this.esqueciSenhaForm.valid) {
      this.authenticationService
        .recuperarSenha(this.esqueciSenhaForm.value.email)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            if (res.sucesso) {
              this.esqueciSenhaMsg.type = 'success';
            } else {
              this.esqueciSenhaMsg.type = 'error';
            }
          },
          (err) => {
            Swal.fire('', err.error.excecao[0].mensagem, 'error');
          }
        );
    } else {
      let form = esqueciSenhaForm.get('email');
      form.markAsTouched({ onlySelf: true });
    }
  }

  submit(form) {
    if (this.loginForm.valid) {
      this.authenticationService
        .login(this.loginForm.value.login,this.loginForm.value.senha)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (user: any) => {
            this.estruturas = JSON.parse(user.param_user);
            console.log('estruturas', this.estruturas);
            if (this.estruturas.length === 1) {
              this.logarEstrutura(
                this.estruturas[0].valor,
                this.estruturas[0].id
              );
            } else {
              this.selecionarEstrutura = true;
            }
          },
          (err) => {
            console.log('err', err);
            Swal.fire('', 'Login e/ou senha inválidos.', 'error');
          }
        );
    } else {
      Object.keys(form.controls).forEach((field) => {
        const control = form.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  logarEstrutura(name: string, id: string) {
    this.authenticationService
      .logarEstrutura(name, id)
      .subscribe(function (res) {
        this.estrutura = name;
      });
  }

  limpaEsqueciSenha() {
    this.esqueciSenhaMsg = {
      type: '',
    };
    this.email.reset();
  }
}
